'use client'

import { useEffect } from 'react'
import {
  BrandReputationSection,
  CustomerExperienceSection,
  FooterSection,
  FutureDirectionSection,
  HeroSection,
  ProductsSupplyChainSection,
  QuoteSection,
  RevenueGrowthSection,
  Vision2030Section,
  VisionStatementSection,
} from './_components'
import './styles.css'

export default function Vision2030Page() {
  useEffect(() => {
    // Initialize sliders after component mount
    const initSliders = () => {
      const isMobile = window.innerWidth <= 768

      if (isMobile) {
        const $brandReputationEl = window.$('[rel-script="brand-reputation"]')
        if ($brandReputationEl.length) {
          $brandReputationEl.slick({
            slidesToShow: 1.2,
            slidesToScroll: 1,
            cssEase: 'linear',
            arrows: true,
            centerMode: true,
            infinite: false,
            prevArrow:
              '<button type="button" class="slick-prev bg-black p-2 md:p-3 rounded-full">Previous</button>',
            nextArrow:
              '<button type="button" class="slick-next bg-black p-2 md:p-3 rounded-full">Next</button>',
          })
        }
      }

      const $expandHorizonsEl = window.$(
        '[rel-script="expand-horizons-slider"]'
      )
      if ($expandHorizonsEl.length) {
        $expandHorizonsEl.slick({
          autoplay: true,
          autoplaySpeed: 3000,
          speed: 1000,
          arrows: false,
          swipe: true,
          slidesToShow: 1,
          cssEase: 'linear',
          pauseOnFocus: true,
          pauseOnHover: true,
          dots: true,
          dotsClass: 'pagination-dots',
          infinite: true,
        })

        $expandHorizonsEl.on('beforeChange', function () {
          $expandHorizonsEl.slick('slickPause')
        })

        $expandHorizonsEl.on('afterChange', function () {
          $expandHorizonsEl.slick('slickPlay')
          window
            .$(
              '[rel-script="expand-horizons-slider"] .slick-slide[aria-hidden="true"]'
            )
            .attr('tabindex', '-1')
          window
            .$(
              '[rel-script="expand-horizons-slider"] .slick-slide:not([aria-hidden="true"])'
            )
            .attr('tabindex', '0')
        })
      }
    }

    // Check for both jQuery and Slick before initializing
    const initializeWhenReady = () => {
      if (
        typeof window.jQuery === 'function' &&
        typeof window.jQuery.fn.slick === 'function'
      ) {
        initSliders()
        return true
      }
      return false
    }

    // Try to initialize immediately
    if (!initializeWhenReady()) {
      // If not ready, set up an interval to check
      const checkLibsInterval = setInterval(() => {
        if (initializeWhenReady()) {
          clearInterval(checkLibsInterval)
        }
      }, 100)

      // Clean up interval after 5 seconds if libraries haven't loaded
      setTimeout(() => clearInterval(checkLibsInterval), 5000)

      return () => {
        clearInterval(checkLibsInterval)
      }
    }
  }, [])

  return (
    <>
      <HeroSection />
      <VisionStatementSection />
      <QuoteSection />
      <Vision2030Section />
      <RevenueGrowthSection />
      <FutureDirectionSection />
      <ProductsSupplyChainSection />
      <BrandReputationSection />
      <CustomerExperienceSection />
      <FooterSection />

      <style jsx global>{`
        .section-bg-black-gradient {
          background: linear-gradient(266.19deg, #191919 0%, #292929 114.65%);
        }

        .section-bg-white-gradient {
          background: linear-gradient(83.16deg, #ffffff 0%, #f1f1f1 100%);
        }

        @media (max-width: 768px) {
          [rel-script='brand-reputation'] .slick-slide {
            padding: 0 10px;
          }

          [rel-script='brand-reputation'] .slick-prev {
            position: absolute;
            top: 50%;
            left: 0;
            transform: translateY(-50%);
            z-index: 1;
          }

          [rel-script='brand-reputation'] .slick-next {
            position: absolute;
            top: 50%;
            right: 0;
            transform: translateY(-50%);
            z-index: 1;
          }

          [rel-script='brand-reputation'] .slick-list {
            padding: 0 !important;
          }

          [rel-script='brand-reputation'] .slick-prev svg,
          [rel-script='brand-reputation'] .slick-next svg {
            color: white;
          }

          #bg-slider {
            padding: 24px 20px;
          }
        }

        .pagination-dots {
          display: flex;
          justify-content: center;
          margin: 0;
          padding: 1rem 0;
          list-style-type: none;
        }

        .pagination-dots li {
          margin: 0 0.25rem;
        }

        .pagination-dots button {
          display: block;
          width: 0.5rem;
          height: 0.5rem;
          padding: 0;
          border: 2px solid #bbbbbb;
          border-radius: 100%;
          background-color: transparent;
          text-indent: -9999px;
        }

        .pagination-dots li.slick-active button {
          background-color: #333333;
          border: 2px solid #333333;
        }

        [rel-script='expand-horizons-slider'] .slick-slide {
          padding: 0 20px;
        }

        [rel-script='collection-banner-video'] iframe {
          position: absolute;
          top: 0;
          left: 0;
          width: 100vw;
          height: 100vh;
          object-fit: cover;
          pointer-events: none;
        }
      `}</style>
    </>
  )
}
